module.exports = __webpack_public_path__ + "img/dp01.45f46352.jpg";